import React, { useState, lazy, Suspense, useCallback, useEffect, useContext } from "react"
import styled from "styled-components"
import Store from "@airasia/phoenix-widgets/widgets/Store"
import FSW_DATA from "../data/phoenix/searchWidget"
import Title from "@airasia/phoenix-components/components/Title"
// import FlightSearchWidget from "@airasia/phoenix-widgets/widgets/FlightSearchWidget"
import _ from "lodash"
import Axios from "axios"
import { GlobalContext } from "../functions"


import {
  TOMORROW_DDMMYYY,
  THREE_DAYS_FROM_TODAY_DDMMYYY,
} from "../utils/constant"
import { splitRouteNameToArray } from "../utils/function"
import axios from "axios"
import { CircularProgress, Icon, TextField } from "@material-ui/core"
import Typewriter from "./TypeWriter"
import { Button } from "@airasia/phoenix-components/components"
import SearchIcon from "@material-ui/icons/Search"
import { isBefore } from "date-fns"

import Loadable from "@loadable/component"

const FlightSearchWidget = Loadable(() => import("@airasia/phoenix-widgets/widgets/FlightSearchWidget"))

const phAirports = ['ZAM', 'WNP', 'VRC', 'TWT', 'TUG', 'USU', 'OZC', 'PAG', 'MNL', 'MPH', 'BCD', 'BAG', 'ILO', 'IAO', 'GES', 'TBH', 'RXS', 'SJI', 'SWL', 'TAC', 'TAG', 'SUG', 'DVO', 'CYP', 'DPL', 'DRP', 'EUQ', 'CYZ', 'DGT', 'ENI', 'PPS', 'LAO', 'MBT', 'CRM', 'CRK', 'CBO', 'BXU', 'BSO', 'CGY', 'CEB', 'CGM', 'KLO', 'RXS', 'OZC', 'PAG', 'SUG', 'PPS', 'BCD', 'BAG', 'BSO', 'BXU', 'CBO', 'LGP', 'CEB', 'CGM', 'SJI', 'CGY', 'LAO', 'MBT', 'MNL', 'KLO', 'MPH', 'TWT', 'TUG', 'SWL', 'USU', 'VRC', 'TAC', 'WNP', 'TAG', 'TBH', 'ZAM', 'GES', 'CRK', 'CRM', 'ENI', 'DVO', 'DPL', 'IAO', 'DGT', 'ILO', 'CYZ', 'CYP'];
const koAirports = ['ICN','GMP','CJU','PUS','TAE','CJJ','MWX','YNY','USN', 'KWJ', 'RSU'];
const khAirports = ['PNH', 'REP', 'KOS', 'SAI'];
const viAirports = ['HAN','SGN','DAD','CXR','PQC','HPH','VCA','DLI','HUI','VII'];
const sgAirports = ['SIN', 'XSP'];
// import "../Css/phoenix.css"

// import Loadable from "@loadable/component"

// const FlightSearchWidget = Loadable(() => import("./FlightSearchWidget"))

const BigTitle = styled(Title)(
  ({template}) => `
  font-size: 3rem !important;
  text-align: left !important;
  margin-bottom: 16px;
  @media only screen and (min-width: 768px) {
    margin-bottom: 0px;
    ${template==="home" ? "" : "box-shadow: 0px -1px 4px rgba(0,0,0,0.16);"}
    border-radius: ${template==='home' ? "0px 0px 0px 0px": "32px 32px 0px 0px"};
    padding-inline: 16px;
    padding-block: 8px;
  }
`
);

// const BannerContainer = styled.div(
//   ({ image, isLarger, isType2 }) => `
   
//     height: ${isType2 ? '25vw' : isLarger ? '80vh' : '450px'};
//     ${isLarger ? 'min-height : 600px;' : ''}
//     width: 100%;
//     background: 50% 50% / 60% no-repeat;
//     background-position: center 100%;
//     background-image: url(${image});
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     flex-direction: column;
//     position:relative;
//     display: inline-block;

//     &:before{
//       width: 100%;
//       height: 100%;
//       background-image: inherit;
//       background-repeat: no-repeat;
//       background-position: inherit;
//       content: " ";
//       display: inline-block;
//       filter: blur(30px);
//     }

//     &:after{
//       position: absolute;
//       left: 0;
//       top: 0;
//       background-origin: content-box;
//       background-size: inherit;
//       width: 100%;
//       height: 100%;
//       background-image: inherit;
//       background-repeat: no-repeat;
//       background-position: inherit;
//       content: " ";
//       display: inline-block;
//     }
// `
// )


const BannerContainer = styled.div(
  ({ image, isLarger, isType2 }) => `
   
    height: ${isType2 ? '25vw' : isLarger ? '80vh' : '450px'};
    ${isLarger ? 'min-height : 600px;' : ''}
    width: 100%;
    background: 50% 50% / cover no-repeat;
    background-position: center;
    background-image: url("${image}");
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position:relative;
    display: inline-block;
`
)

const MobileBannerContainer = styled.div(
  ({image, isType2 }) => `
   {
    width: 100%;
    height: ${isType2 ? '25vw' : '69vw'};
    background: ${isType2 ? '100% / cover no-repeat' : '50% 50% / cover no-repeat'};
    background-position: center;
    background-image: url("${image}"), url("https://storage.googleapis.com/static.stgairasia.com/seo/static-assets/SEOFlightsImages/hero/just-sky.jpeg");
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-bottom: 16px;
  }
`
)
const StyledHeading = styled.div`
  margin: 10px;
  color: black;
  #banner-title {
    font-size: 1.6rem;
    line-height: 38px;
    color: black;
  }
`

const FswContainer = styled.div`
  padding: 16px 48px;
  background: white;
  width: fit-content;
  margin-inline: auto;
  @media only screen and (min-width: 1080px){
    padding: 16px;

    padding: 16px;
    bottom: 2%;
    margin-inline: 5%;
    width: 100%;
    margin-bottom: 1%;
  }
`;

const HSW_Wrapper = styled.div`
  margin: 20px;
  // background: white;
  // padding: 30px;
  // border-radius: 20px;
  // height: 150px;
  // width: 880px;
  display: block;
  @media only screen and (min-width: 1080px){
    margin: 0 5%;

    margin: 0 auto;
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: end;
  }
  @media only screen and (max-width: 1440px) {
    width: 1080px;
    // height: 150px;

    margin: 0 auto;
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: end;
  }

  @media only screen and (max-width: 1024px) {
    width: 880px;
    // height: 150px;

    margin: 0 auto;
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: end;
  }

  @media only screen and (max-width: 768px) {
    margin: 0 50px 50px 50px;
    padding: 10px;
    align-self: stretch;
    width: 650px;
    height: 440px;
  }

  @media only screen and (max-width: 600px) {
    margin: 0 20px 20px 20px;
    padding: 10px;
    align-self: stretch;
  }

  @media only screen and (max-width: 540px) {
    margin: 0 20px 20px 20px;
    padding: 10px;
    align-self: stretch;
    width: 460px;
    height: 545px;
  }
  @media only screen and (max-width: 414px) {
    width: 350px;
    height: 545px;
  }
  @media only screen and (max-width: 375px) {
    width: 315px;
    height: 545px;
  }
  @media only screen and (max-width: 360px) {
    width: 300px;
    height: 545px;
  }
  @media only screen and (max-width: 320px) {
    width: 260px;
    height: 545px;
  }
  @media only screen and (max-width: 280px) {
    width: 250px;
    height: 545px;
    margin: 0 20px 20px 5px;
  }
 
`
const HSW_Wrapper_Mobile = styled.div`
  margin: 20px;
  background: white;
  padding: 30px;
  border-radius: 4px;
  /* height: 415px;
  width: 260px; */

  /* width: 880px; */
  @media only screen and (max-width: 1024px) {
    width: 880px;
    height: 120px;
  }

  @media only screen and (max-width: 768px) {
    // margin: 0 50px 50px 50px;
    margin: auto;
    padding: 1px;
    align-self: stretch;
    width: 85vw;
    max-width: 720px;
    // height: 545px;
    height: auto;
  }

  @media only screen and (max-width: 600px) {
    // margin: 0 20px 20px 20px;
    margin: auto;
    padding: 10px;
    align-self: stretch;
  }

  @media only screen and (max-width: 540px) {
    // margin: 0 20px 20px 20px;
    margin: auto;
    padding: 1px;
    // align-self: stretch;
    width: 85vw;
    // height: 545px;
    height: auto;

  }
  @media only screen and (max-width: 414px) {
    width: 350px;
    // height: 545px;
    height: auto;
    padding: 1px;

  }
  @media only screen and (max-width: 375px) {
    width: 315px;
    // height: 545px;
    height: auto;

  }
  @media only screen and (max-width: 360px) {
    width: 300px;
    // height: 545px;
    height: auto;

  }
  @media only screen and (max-width: 320px) {
    width: 260px;
    // height: 545px;
    height: auto;

  }
  @media only screen and (max-width: 280px) {
    width: 250px;
    // height: 545px;
    height: auto;
    margin: 0 20px 20px 5px;
  }
 
`

const MobileContainer = styled.div`
   @media only screen and (min-width: 769px) {
    display: none;
   }
`

const DesktopContainer = styled.div`
   @media only screen and (max-width: 768px) {
    display: none;
   }
`

const TextFieldDiv = styled.div`
   margin: auto;
   cursor: pointer;
   width: 85vw;
   height: 40px;
   border: 1px solid #75767A;
   border-radius: 4px;
   display: flex;
   align-items: center; 
   padding-inline: 16px;
   color: #75767A;
   justify-content: space-between;
`;

const getSnapAvailability = async (searchObj) => {
  let bodyData = {
    "vars": ["snap_flight_price_checkbox"],
    "env": "production",
    "tags": {
      "airportOrig": _.get(searchObj, 'origin.StationCode', ""),
      "airportDest": _.get(searchObj, 'destination.StationCode', ""),
      "journeyType": _.get(searchObj, 'tripType', ""),
      "promoCode": _.get(searchObj, 'promoCode', ""),
      "adults": _.get(searchObj, 'passengers.adult', 0),
      "children": _.get(searchObj, 'passengers.child', 0),
      "infant": _.get(searchObj, 'passengers.infant', 0),
      "platform": "dweb",
      // "user_id": "GA1.2.378908598.1652076962"
    }
  }

  return await Axios.post(process.env.GATSBY_ENV === 'dev' ? '/relay-api/relay/query' : 'https://track.data.airasia.com/relay/query', bodyData).then(resp => {
    console.log('resp from getSnapAvailability --- ', resp);
    let snapDataRaw = _.get(resp, 'data.snap_flight_price_checkbox.value');
    let snapData = _.isString(snapDataRaw) ? JSON.parse(snapDataRaw) : snapDataRaw;
    return _.get(snapData, 'is_enabled', false)
  }).catch(err => {
    console.log('err from getSnapAvailability --- ', err);
    return false;
  })

}

export default function Banner(props) {
  const { image, title, isMobile, currentRoute } = props
  const [showMobileFSW, setShowMobileFSW] = useState(false);
  const [isSnapAvailable, setIsSnapAvailable] = useState(false);
  const [fswData, setFswData] = useState(FSW_DATA.data);
  const [isLoadingFSWData, setIsLoadingFSWData] = useState(true);
  const globalState = useContext(GlobalContext)


  useEffect(()=>{
    setIsLoadingFSWData(true);
    axios.get(`https://static.airasia.com/cosmos/universalsearchwidget/flight/${props.lang}/file.json`).then(resp => {
      setFswData(_.get(resp, "data", {}));
      setIsLoadingFSWData(false);
    }).catch(err => {
      console.error("Error fetching universal search widget props::: ", err);
      setIsLoadingFSWData(false);
    })
  }, [])

  // const isOnClient = typeof window !== "undefined"
  if (typeof window !== "undefined") {
    window.gtmDataLayer = window.gtmDataLayer || []
  }
  const onMobileBannerClick = () => {
    setShowMobileFSW(true)
  }
  const FSWGtmFire = () => {
    const obj = {
      event: "trackEventNoEcommerce",
      "eventDetails.category": "SEO Flights | Search Widget",
      "eventDetails.action": `view`,
      "eventDetails.label": `Flights Widget Exposed`,
    }

    if (typeof window !== "undefined") {
      window.gtmDataLayer = window.gtmDataLayer || []
      window.gtmDataLayer.push(obj)
    }
  }
  const onMobileFSWClose = () => {
    document.body.style.overflow = "auto"
    setShowMobileFSW(false)
  }

  const route = currentRoute
    ? splitRouteNameToArray(currentRoute)
    : ["KUL", "LGK"]
  const fswPrefill = {
    depart: TOMORROW_DDMMYYY,
    from: route[0],
    passengers: {
      adult: 2,
      child: 0,
      infant: 0,

    },
    return: THREE_DAYS_FROM_TODAY_DDMMYYY,
    to: route[1],
    tripType: "R",
    // cabinClass: "economy"
  }



  const handleSearchChange = useCallback(async (searchObj) => {
    let isAvailable = await getSnapAvailability(searchObj);
    console.log('isAvailable from handleSearchChange --- ', isAvailable);
    setIsSnapAvailable(isAvailable);
  }, [getSnapAvailability])

  const [currency, setCurrency] = useState(()=>{
    let temp = _.get(globalState, "currency", "MYR");
    return temp
  });

  useEffect(()=>{
    console.log("changing the currency from useEffect --- ", _.get(globalState, "currency", ""));
    // dispat
    setCurrency(()=>{
      let temp = _.get(globalState, "currency", "MYR");
      return temp
    })
  }, [globalState])

  const [isMobileWidgetOpen, setIsMobileWidgetOpen] = useState(false);
  const handleWidgetVisible = () => {
    if(isMobileWidgetOpen && typeof(document)){
      document.querySelector('body').style = "overflow: auto;"
    }
    setIsMobileWidgetOpen(c => !c); console.log("closeSearchWidget");
  };

  // image = (_.startsWith(props.currentRoute, "SIN") || _.startsWith(props.currentRoute, "XSP")) ?  "https://static.airasia.com/seo/images/others/SG_EN_D.jpg" : "https://static.airasia.com/seo/images/others/ID_payday_EN_D.png"

  const [bannerImages, setBannerImages] = useState({m: '', d: ''}) 
  const getImage = (size) => {

    let returnObj = {
      m: image, d: image
    }

    let posCountry = _.lowerCase(_.get(props, 'posCountry', 'MY'));
    let langCode = props.lang.split('-')[0];
    let posLang = posCountry + langCode;
    
    let isCambodia = props.url.includes('cambodia');
    let key = props.lang + (isCambodia ? '-cambodia' : '');
    

    // if(isBefore(new Date(), new Date(2024, 10, 14, 23, 59, 59))){
    //   key = posCountry + '_' + langCode;
    // }

    if(!_.isEmpty(_.get(props, 'heroImages.desktop'))){
      key = 'useheroimages';
    }
    
    switch (key) {
      case 'useheroimages': {
        let heroImages = _.get(props, 'heroImages');
        let image = heroImages.desktop;
        let mobileImage = heroImages.mobile;
        returnObj = { m: mobileImage, d: image };
        break;
      }
      default: {
        returnObj = {
          d: "https://static.airasia.com/seo/images/others/asaf_oct_24_d.jpg",
          m: "https://static.airasia.com/seo/images/others/asaf_oct_24_m.jpg",
        }
        break;
      }
    }

    if(size){
      return returnObj.size
    }else{
      return returnObj
    }
    // if(props.lang === 'id-id'){
    //   returnObj = {m: 'https://static.stgairasia.com/seo/static-assets/SEOAssets/campaigns/se-id-id-m.jpg', d: 'https://static.stgairasia.com/seo/static-assets/SEOAssets/campaigns/se-id-id-d.jpg'}
    // }else if(props.lang === 'th-th'){
    //   returnObj = {m: 'https://static.stgairasia.com/seo/static-assets/SEOAssets/campaigns/se-th-th-m.png', d: 'https://static.stgairasia.com/seo/static-assets/SEOAssets/campaigns/se-th-th-d.png'}
    // }else{
    //   const orgCode = props?.currentRoute?.substring(0, 3)?.toUpperCase();
    //   if(_.includes(phAirports, orgCode)){
    //     returnObj = {m: 'https://static.stgairasia.com/seo/static-assets/SEOAssets/campaigns/se-en-ph-m.jpg', d: 'https://static.stgairasia.com/seo/static-assets/SEOAssets/campaigns/se-en-ph-d.jpg'}
    //   }else if(_.includes(koAirports, orgCode)){
    //     returnObj = {m: 'https://static.stgairasia.com/seo/static-assets/SEOAssets/campaigns/se-en-ko-m.jpg', d: 'https://static.stgairasia.com/seo/static-assets/SEOAssets/campaigns/se-en-ko-d.jpg'}
    //   }else if(_.includes(khAirports, orgCode)){
    //     returnObj = {m: 'https://static.stgairasia.com/seo/static-assets/SEOAssets/campaigns/se-en-kh-m.png', d: 'https://static.stgairasia.com/seo/static-assets/SEOAssets/campaigns/se-en-kh-d.png'}
    //   }else if(_.includes(viAirports, orgCode)){
    //     returnObj = {m: 'https://static.stgairasia.com/seo/static-assets/SEOAssets/campaigns/se-en-vi-m.jpg', d: 'https://static.stgairasia.com/seo/static-assets/SEOAssets/campaigns/se-en-vi-d.jpg'}
    //   }else if(_.includes(sgAirports, orgCode)){
    //     returnObj = {m: 'https://static.stgairasia.com/seo/static-assets/SEOAssets/campaigns/se-en-sg-m.jpg', d: 'https://static.stgairasia.com/seo/static-assets/SEOAssets/campaigns/se-en-sg-d.jpg'}
    //   }else{
    //     returnObj = {m: 'https://static.stgairasia.com/seo/static-assets/SEOAssets/campaigns/se-en-gb-m.jpg', d: 'https://static.stgairasia.com/seo/static-assets/SEOAssets/campaigns/se-en-gb-d.jpg'}
    //   }
    // }

  };

  useEffect(()=>{
    let tempImage = getImage();
    setBannerImages(tempImage)
  }, [props.lang, props.posCountry])

  return (
    <>
        {/* {isMobile ? ( */}
          <MobileContainer>
            <MobileBannerContainer image={bannerImages['m']} isType2={props.bannerType2}>
              
            </MobileBannerContainer>
            <div>
              <StyledHeading>
                <Title
                  type={isMobile?"h1":"h2"}
                  color="black"
                  customProperties={{
                    id: "banner-title",
                  }}
                  textAlign="center"
                >
                  {isMobile?title:""}
                </Title>
              </StyledHeading>
              <TextFieldDiv onClick={handleWidgetVisible}>
                <Typewriter text="My React App" delay={100} infinite 
                {...(props.lang==='th-th'?{textArray:['กัวลาลัมเปอร์', 'โตเกียว', 'บาหลี']}:{})} 
                />
                <SearchIcon />
              </TextFieldDiv>
                <HSW_Wrapper_Mobile>
                  <Store>
                    {
                      isLoadingFSWData 
                        ? <div style={{display: "grid", placeItems: "center"}}><CircularProgress /> </div>
                        : isMobileWidgetOpen ? <FlightSearchWidget
                            // accessible
                            // currency={_.get(globalState, "currency", "MYR")}
                            currency={props?.currency || ""}
                            // data={FSW_DATA.data}
                            data={fswData}
                            enableDataVisor={false}
                            enableLFC={false}
                            enableLFCV2
                            domain="com"
                            enableOnSearchCookieReset
                            // endpointConfig={FSW_DATA.endpointConfig}
                            endpointConfig={JSON.parse(JSON.stringify(_.get(fswData, "ENDPOINT_CONFIG[0].data", FSW_DATA.endpointConfig)).replaceAll('/v2', '/v3'))}
                            // environment={["dev", "stg"].includes(process.env.GATSBY_ENV) ? "STAGING" : "PRODUCTION"}
                            environment={process.env.GATSBY_ENV === "dev" ? "DEVELOPMENT" : process.env.GATSBY_ENV === "stg" ? "STAGING" : "PRODUCTION"}
                            invertSearchButtonStyle={false}
                            isEdit={false}
                            isSearchWidgetOpenByDefault={false}
                            isShowSnapCheckbox={isSnapAvailable}
                            isShowSnapInNewWindow={false}
                            locale={props.lang}
                            onValueChange={function noRefCheck(){}}
                            openContextualSearchWidgetbyDefault={false}
                            redirectUrl="https://www.airasia.com"
                            showBackGroundColor="default"
                            showBorder={false} 
                            showIconBackground={false}
                            showMobileViewWithoutModal={false}
                            theme={props?.theme || "AIRASIA_MOVE"}
                            showCabinClass
                            unifiedListingConfig={{airlineProfile: "all", type: "bundled"}}
                            viewport="mobile"
                            closeSearchWidget={handleWidgetVisible}
                            // preFill={fswPrefill}
                            fireGtm={obj => {
                              try{
                                if(typeof(window) !== "undefined"){
                                  window.gtmDataLayer.push(obj)
                                }
                              }catch(err){
                                console.error("Error pushing to gtmDataLayer --- ", err)
                              }
                            }}
                            originOrDestinationNotFoundEventHandler={obj => {
                              try{
                                if(typeof(window) !== "undefined"){
                                  window.gtmDataLayer.push(obj)
                                }
                              }catch(err){
                                console.error("Error in firing GTM event", err);
                              }
                            }}
                            useV3Bucket
                            cityLevelGrouping
                            isAirAsiaFlightOnlyCheckbox
                            enableTravelSearchService
                          airAsiaFlightOnlyValueFromListing
                            gtmParameters={{appName: "SEO Flights"}}
                      /> : null
                    }
                     
                  </Store>
                </HSW_Wrapper_Mobile>
            </div>
          </MobileContainer>
          <DesktopContainer>
            <BannerContainer image={bannerImages['d']} isType2={props.bannerType2}>
            </BannerContainer>
              <HSW_Wrapper isType2={props.bannerType2}>
                <Store>
                  <FswContainer>
                  <BigTitle type={!isMobile ? "heroBanner" : "h2"} template={props.template} color="black">
                  {!isMobile ? title : ""}
                </BigTitle>
                    {
                      isLoadingFSWData
                        ? <div style={{ display: "grid", placeItems: "center" }}><CircularProgress /> </div>
                        : <FlightSearchWidget
                          // accessible
                          agentId={null}
                          beforeRedirectHandler={null}
                          closeSearchWidget={function noRefCheck() { }}
                          // currency={_.get(globalState, "currency", "USD")}
                          // currency={currency}
                          currency={props?.currency || ""}
                          // data={FSW_DATA.data}
                          data={fswData}
                          enableDataVisor={false}
                          enableLFC={false}
                          enableLFCV2
                          domain="com"
                          enableOnSearchCookieReset
                          // endpointConfig={_.get(fswData, "ENDPOINT_CONFIG[0].data", {})}
                          endpointConfig={JSON.parse(JSON.stringify(_.get(fswData, "ENDPOINT_CONFIG[0].data", FSW_DATA.endpointConfig)).replaceAll('/v2', '/v3'))}
                          environment={process.env.GATSBY_ENV === "dev" ? "DEVELOPMENT" : process.env.GATSBY_ENV === "stg" ? "STAGING" : "PRODUCTION"}
                          // environment={"PRODUCTION"}
                          invertSearchButtonStyle={false}
                          isEdit={false}
                          isSearchWidgetOpenByDefault={false}
                          isShowSnapCheckbox={isSnapAvailable}
                          isShowSnapInNewWindow={false}
                          locale={props.lang}
                          onValueChange={handleSearchChange}
                          openContextualSearchWidgetbyDefault={false}
                          redirectUrl="https://www.airasia.com"
                          showBackGroundColor="default"
                          showBorder={true}
                          showIconBackground={false}
                          showMobileViewWithoutModal={false}
                          theme={props?.theme || "AIRASIA_MOVE"}
                          showCabinClass
                          unifiedListingConfig={{ airlineProfile: "all", type: "bundled" }}
                          viewport="desktop"
                          // preFill={fswPrefill}
                          fireGtm={obj => {
                            try{
                              if(typeof(window) !== "undefined"){
                                window.gtmDataLayer.push(obj)
                              }
                            }catch(err){
                              console.error("Error pushing to gtmDataLayer --- ", err)
                            }
                          }}
                          originOrDestinationNotFoundEventHandler={obj => {
                            try{
                              if(typeof(window) !== "undefined"){
                                window.gtmDataLayer.push(obj)
                              }
                            }catch(err){
                              console.error("Error in firing GTM event", err);
                            }
                          }}
                          gtmParameters={{ appName: "SEO Flights" }}
                          useV3Bucket
                          cityLevelGrouping
                          isAirAsiaFlightOnlyCheckbox
                          airAsiaFlightOnlyValueFromListing
                          enableTravelSearchService
                        />
                    }

                  </FswContainer>
                </Store>
              </HSW_Wrapper>
          </DesktopContainer>
      </>
  )
}
